<template>
  <div id="tab2" class="tab-panel">
    <div class="row">
      <div class="col-md-12">
        <!-- Main Form -->
        <div class="login-form-1">
          <form id="login-form-2" action="#">
            <h3 class="text-center no-margin-top">Забыл пароль?</h3>
            <p class="mar-bot-20 text-center">
              Введи свой E-mail адрес, на него придет ссылка для восстановления
              пароля.
            </p>
            <div class="main-login-form text-left">
              <div class="login-group">
                <div class="form-group">
                  <input
                    @input="keypress"
                    type="email"
                    class="form-control"
                    id="lg_email"
                    name="email"
                    :value="email"
                    placeholder="email"
                    autocomplete="off"
                  />
                </div>
              </div>
              <button
                v-if="!loading"
                @click="resetPassword"
                type="button"
                class="login-button"
              >
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
            <div class="etc-login-form text-center text-main">
              <p @click="auth" class="mar-top-15 no-margin-bottom">
                <a><b>Войти</b></a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["loading", "email"],
  methods: {
    auth() {
      this.$router.push({ name: "auth" });
    },
    keypress(ev) {
      this.$emit("handleInput", ev);
    },
    resetPassword(ev) {
      this.$emit("resetPassword", ev);
    }
  }
};
</script>
